import { defineMessages } from "@/i18n";
import en from "./en";

export const onboardingContextualMessages = defineMessages(
  "onboarding-contextual",
  en,
);
